import { Building2 } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";

const LOGO_SAUCEDO = "/assets/images/logo-saucedo.webp";
const LOGO_BLACKSTONE = "/assets/images/logo-blackstone.webp";
const LOGO_DREAMHOMES = "/assets/images/logo-dreamhomes.webp";

const ProjectBackingSection = () => {
  const { t } = useLanguage();

  const companies = [
    { logo: null, icon: Building2, title: t.backing.developer, name: "Constructora Ahjel", desc: null },
    { logo: LOGO_DREAMHOMES, title: t.backing.construction, name: "Dream Homes", desc: t.backing.constructionDesc },
    { logo: LOGO_BLACKSTONE, title: t.backing.sales, name: "Blackstone Real Estate", desc: t.backing.salesDesc },
    { logo: LOGO_SAUCEDO, title: t.backing.legal, name: "Saucedo Abogados", desc: t.backing.legalDesc },
  ];

  return (
    <section className="py-16 md:py-20 bg-[#FAF8F5]" data-testid="backing-section">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <span className="text-xs uppercase tracking-[0.3em] text-[#B5613B] font-accent mb-4 block text-center">{t.backing.label}</span>
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-[#2D2926] text-center mb-6" data-testid="backing-title">{t.backing.title}</h2>
        <div className="max-w-3xl mx-auto text-center mb-14">
          <p className="text-[#6B6560] leading-relaxed">{t.backing.desc}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {companies.map((company, index) => (
            <div key={index} className="bg-white p-8 text-center shadow-sm hover:shadow-md transition-shadow duration-300" data-testid={`partner-card-${index}`}>
              <div className="h-20 flex items-center justify-center mb-6">
                {company.logo ? (
                  <img src={company.logo} alt={company.name} className="max-h-20 max-w-[160px] object-contain" />
                ) : (
                  <div className="w-16 h-16 rounded-full bg-[#B5613B]/10 flex items-center justify-center">
                    <company.icon className="w-8 h-8 text-[#B5613B]" />
                  </div>
                )}
              </div>
              <span className="text-xs uppercase tracking-widest text-[#B5613B] block mb-2">{company.title}</span>
              <h4 className="font-heading text-xl text-[#2D2926] mb-3">{company.name}</h4>
              {company.desc && <p className="text-sm text-[#6B6560] leading-relaxed">{company.desc}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectBackingSection;
